import {parseModelSelectId} from './format-model-select-id';
import {
  BffTrimData,
  ChargeTimeTrimModel,
  CostTrimModel,
  RangeTrimModel,
} from '@volkswagen-onehub/whitelabel-e-mobility-data-types';

type SimulatorTrimModel = CostTrimModel | RangeTrimModel | ChargeTimeTrimModel;

function findModel<T>(
  trim: BffTrimData<T>,
  modelEngineId: string
): T | undefined {
  const {id, year, version} = parseModelSelectId(modelEngineId);

  return trim.modelVariants.find((m) => {
    const model = m as unknown as SimulatorTrimModel;
    return model.id === id && model.year === year && model.version === version;
  });
}

export function getSelectedModel<T>(
  trim: BffTrimData<T>,
  modelEngineId: string
): T {
  const model = findModel<T>(trim, modelEngineId);

  if (!model) {
    throw new Error('Invalid form state');
  }

  return model;
}
